import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { sellerApi } from '../api/seller.api';
import { switchMap, map } from 'rxjs/operators';

import { SellerData } from '../../../interfaces/masters/seller' ;
@Injectable({
  providedIn: 'root'   
})
export class SellerService extends SellerData {

    constructor(private api: sellerApi) {
      super();
    }
  
  
    list(url: string): Observable<any[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<any>{
        return this.api.getById(url);
    }
  
    create(url: string, data:any): Observable<any[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:any): Observable<any> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  